import searchParams from '../constants/searchParams'

const filterParts = (parts, filter) => {
    const priceFrom = filter.priceFrom
    const priceTo = filter.priceTo
    const isInStock = filter.isInStock
    const isOfDealer = filter.isOfDealer
    const delivery = filter.delivery
    const quantityFrom = filter.quantityFrom
    const quantityTo = filter.quantityTo
    const brand = filter.brand

    return parts.filter((part) => {
        return (
            (priceFrom <= 0 || part['price_src'] >= priceFrom) &&
            (priceTo <= 0 || part['price_src'] <= priceTo) &&
            (!isInStock || searchParams['KENTEK_SUPPLIERS'].includes(part['supplier_id'])) &&
            (!isOfDealer || searchParams['OFFICIAL_MANUFACTURERS'].includes(part['brand_title'])) &&
            (delivery === 'any' ||
                (delivery === 'now' && part['delivery'] <= 24) ||
                (delivery === 'tomorrow' && part['delivery'] <= 24 * 2) ||
                (delivery === 'five' && part['delivery'] <= 24 * 5)) &&
            (quantityFrom <= 0 || part['quantity'] >= quantityFrom) &&
            (quantityTo <= 0 || part['quantity'] <= quantityTo) &&
            (!brand.length || brand.indexOf(part.brand_title) !== -1)
        )
    })
}

export default filterParts
